import React from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export default function ExportToExcel({ apiData = [], fileName, headers = [] }) {


  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = (apiData, fileName, headers) => {
    if (!Array.isArray(headers) || headers.length === 0) return;

    // Format data
    const formattedData = apiData.map((row) =>
      headers.reduce((formattedRow, header) => {
        formattedRow[header.label] = row[header.key] || "";
        return formattedRow;
      }, {})
    );

    // Header row
    const headerRow = headers.map((header) => header.label);
    const dataRows = formattedData.map((row) =>
      headers.map((header) => row[header.label])
    );

    const dataWithHeaders = [headerRow, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders);

    // Column width adjust
    const colWidths = headers.map((header) => ({
      width: Math.max(header.label.length + 5, 15),
    }));
    ws["!cols"] = colWidths;

    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");

    // Save file
    XLSX.writeFile(wb, fileName + fileExtension);
  };

  // Dynamic headers
  const dynamicHeaders =
    headers.length > 0
      ? headers
      : apiData.length > 0
        ? Object.keys(apiData[0]).map((key) => ({
          label: key.replace(/_/g, " "),
          key: key,
        }))
        : [];

  return (
    <button
      onClick={() => exportToExcel(apiData, fileName, dynamicHeaders)}
      type="button"
      className="btn btn-primary btn-sm float-lg-end export-btn"
      title="Export To Excel"
    >
      <i className="fa fa-download" aria-hidden="true"></i> Export Excel
    </button>
  );
}
